export class StsRegexBluePrintModel {
  regexp: RegExp;
  model: any;
}
